import {
	Command,
	EditorState,
	Transaction
} from "prosemirror-state";
import { defaultFontMarksNewParagraphTag } from "../plugins/defaultFontMarksPlugin";

export function withRestoreDefaultFontMarksOnNewParagraph(
	command: Command
): Command {
	return (
		state: EditorState,
		dispatch: ((tr: Transaction) => void) | undefined
	): boolean => {
		return command(
			state,
			dispatch && (
				(tr: Transaction): void => {
					tr.setMeta(defaultFontMarksNewParagraphTag, true);
					dispatch(tr);
				}
			)
		);
	};
}